import { useMemo } from 'react';
import { t } from '@lingui/macro';

import { Button } from '@rover/kibble/core';
import { getIconComponent } from '@rover/react-lib/src/utils/getIconComponent';

type Props = {
  icon: string | null;
  onClick: (event?: React.MouseEvent<HTMLButtonElement>) => void;
};

const AlertInfoButton = ({ icon, onClick }: Props): JSX.Element => {
  const TooltipIcon = useMemo(() => getIconComponent(icon), [icon]);

  const handlePress = ({ webEvent }: { webEvent?: React.MouseEvent<HTMLElement> }): void => {
    onClick(webEvent as React.MouseEvent<HTMLButtonElement>);
  };

  return (
    <Button
      circular
      variant="flat"
      size="small"
      data-testid="tooltip-icon"
      onPress={handlePress}
      aria-label={t`Info`}
      icon={TooltipIcon}
      sx={{ p: '0x', color: 'neutral.900', '&:hover, &:focus': { color: 'neutral.900' } }}
    />
  );
};

export default AlertInfoButton;
